module.exports = __webpack_public_path__ + "assets/media/performance.4e2d6cbf.mp4";